export default __webpack_public_path__ + "static/media/Vector3.4b7a861a.svg";